import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';
import benchmarkUtility from '@sparta.sales.utilities/benchmark-utility/dist/es6.js';
import Handlebars from '@sparta.global.vendors/handlebars';
import { curve } from '@sparta.homepage.helpers/homepage-helper/dist/es6.js';
import { compare } from '@sparta.global.helpers/comparisons-helper/dist/es6.js';
import { picture } from '@sparta.global.helpers/picture-helper/dist/es6.js';
import { link } from '@sparta.global.helpers/sparta-helper/dist/es6.js';

const Template = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.hooks.helperMissing, alias3="function", lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"column small-12\">\r\n  <div class=\"curve\">\r\n    "
    + ((stack1 = (lookupProperty(helpers,"curve")||(depth0 && lookupProperty(depth0,"curve"))||alias2).call(alias1,"top","#fff",{"name":"curve","hash":{},"data":data,"loc":{"start":{"line":10,"column":4},"end":{"line":10,"column":28}}})) != null ? stack1 : "")
    + "\r\n      <div class=\"image-container "
    + ((stack1 = lookupProperty(helpers,"unless").call(alias1,(depth0 != null ? lookupProperty(depth0,"backgroundImage") : depth0),{"name":"unless","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":11,"column":34},"end":{"line":11,"column":96}}})) != null ? stack1 : "")
    + "\">\r\n        <div class=\"image-container-overlay row\">\r\n          <div class=\"overlay-content small-offset-1 small-11 medium-5 column\">\r\n            <p class=\"overlay-content--heading\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"content") || (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"content","hash":{},"data":data,"loc":{"start":{"line":14,"column":48},"end":{"line":14,"column":61}}}) : helper))) != null ? stack1 : "")
    + "</p>\r\n            <p class=\"overlay-content--subheading\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"subContent") || (depth0 != null ? lookupProperty(depth0,"subContent") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"subContent","hash":{},"data":data,"loc":{"start":{"line":15,"column":51},"end":{"line":15,"column":67}}}) : helper))) != null ? stack1 : "")
    + "</p>\r\n            "
    + ((stack1 = (lookupProperty(helpers,"link")||(depth0 && lookupProperty(depth0,"link"))||alias2).call(alias1,(depth0 != null ? lookupProperty(depth0,"link") : depth0),{"name":"link","hash":{},"data":data,"loc":{"start":{"line":16,"column":12},"end":{"line":16,"column":27}}})) != null ? stack1 : "")
    + "\r\n          </div>\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"foregroundImage") : depth0),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":18,"column":10},"end":{"line":22,"column":17}}})) != null ? stack1 : "")
    + "        </div>\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"backgroundImage") : depth0),{"name":"if","hash":{},"fn":container.program(6, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":24,"column":8},"end":{"line":28,"column":15}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"backgroundGraphic") : depth0),{"name":"if","hash":{},"fn":container.program(8, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":29,"column":8},"end":{"line":31,"column":15}}})) != null ? stack1 : "")
    + "      </div>\r\n    "
    + ((stack1 = (lookupProperty(helpers,"curve")||(depth0 && lookupProperty(depth0,"curve"))||alias2).call(alias1,"bottom","#0073CF",{"name":"curve","hash":{},"data":data,"loc":{"start":{"line":33,"column":4},"end":{"line":33,"column":34}}})) != null ? stack1 : "")
    + "\r\n  </div>\r\n</div>\r\n";
},"2":function(container,depth0,helpers,partials,data) {
    return "without-background-image";
},"4":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "            <div class=\"overlay-foreground-image small-12 medium-6 column\">\r\n              "
    + container.escapeExpression((lookupProperty(helpers,"picture")||(depth0 && lookupProperty(depth0,"picture"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"foregroundImage") : depth0),{"name":"picture","hash":{},"data":data,"loc":{"start":{"line":20,"column":14},"end":{"line":20,"column":41}}}))
    + "\r\n            </div>\r\n";
},"6":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "          <div class=\"background-image\">\r\n            "
    + container.escapeExpression((lookupProperty(helpers,"picture")||(depth0 && lookupProperty(depth0,"picture"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"backgroundImage") : depth0),{"name":"picture","hash":{},"data":data,"loc":{"start":{"line":26,"column":12},"end":{"line":26,"column":39}}}))
    + "\r\n          </div>\r\n";
},"8":function(container,depth0,helpers,partials,data) {
    return "          <div class=\"background-graphic\"></div>\r\n";
},"10":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"column small-12\">\r\n  <div class=\"curve\">\r\n    <div class=\"image-container-blue\">\r\n      <div class=\"row\">\r\n        <div\r\n          class=\"small-8 small-offset-1 medium-6 medium-offset-1 column end\">\r\n          <div class=\"content\">\r\n            <h3 class=\"image-container-blue--heading cnx-regular\">"
    + ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"content") : depth0), depth0)) != null ? stack1 : "")
    + "</h3>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <div class=\"row\">\r\n        <div\r\n          class=\"small-11 small-offset-1 column\">\r\n          <div class=\"link-container\">\r\n            "
    + ((stack1 = (lookupProperty(helpers,"link")||(depth0 && lookupProperty(depth0,"link"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"link") : depth0),{"name":"link","hash":{},"data":data,"loc":{"start":{"line":54,"column":12},"end":{"line":54,"column":32}}})) != null ? stack1 : "")
    + "\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n";
},"12":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"column small-12\">\r\n  <div class=\"curve\">\r\n    "
    + ((stack1 = (lookupProperty(helpers,"curve")||(depth0 && lookupProperty(depth0,"curve"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"top","#fff",{"name":"curve","hash":{},"data":data,"loc":{"start":{"line":66,"column":4},"end":{"line":66,"column":28}}})) != null ? stack1 : "")
    + "\r\n    <div class=\"row\">\r\n      <div\r\n        class=\"small-6 small-centered medium-5 large-4 column end\">\r\n        <div class=\"image-container-white\">\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"row\">\r\n  <div class=\"column\">\r\n    <h2 class=\"heading cnx-regular\">"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"h2Heading") : stack1), depth0)) != null ? stack1 : "")
    + "</h2>\r\n  </div>\r\n</div>\r\n\r\n"
    + ((stack1 = lookupProperty(helpers,"with").call(alias1,((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"imageItem") : stack1),{"name":"with","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":7,"column":0},"end":{"line":36,"column":9}}})) != null ? stack1 : "")
    + "\r\n"
    + ((stack1 = lookupProperty(helpers,"with").call(alias1,((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"imageItemBlue") : stack1),{"name":"with","hash":{},"fn":container.program(10, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":38,"column":0},"end":{"line":61,"column":9}}})) != null ? stack1 : "")
    + "\r\n"
    + ((stack1 = lookupProperty(helpers,"with").call(alias1,((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"imageItemWhite") : stack1),{"name":"with","hash":{},"fn":container.program(12, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":63,"column":0},"end":{"line":76,"column":9}}})) != null ? stack1 : "");
},"useData":true});
const renderTemplate = function (data, options) {
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.homepage.modules/news-information-legacy-module",
  "version": "1.0.1",
  "id": "newsInformationLegacyModule",
  "containerID": "homepageNewsInformationLegacyModule",
  "moduleName": "homepage-news-information-legacy-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "news-information-legacy-module",
  "data": {
    "init": "newsInformationLegacyModuleJS",
    "options": {}
  },
  "moduleParams": [],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate(context, {
      "helpers": {
        curve,
        compare,
        picture,
        link
      },
      "partials": {}
    });
  },
  "template": renderTemplate,
  "partials": {},
  "helpers": {
    curve,
    compare,
    picture,
    link
  },
  "dependencies": {
    "@sparta.global.helpers/comparisons-helper": "^1.0.0",
    "@sparta.global.helpers/picture-helper": "^1.0.0",
    "@sparta.global.helpers/sparta-helper": "^1.0.0",
    "@sparta.global.utilities/sparta-module-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-token-utility": "^1.1.6",
    "@sparta.homepage.helpers/homepage-helper": "^1.0.0",
    "@sparta.sales.utilities/benchmark-utility": "^1.0.0"
  },
  "stores": []
};

/**
 * @class newsInformationLegacyModuleJS
 * @extends {Module}
 */
class newsInformationLegacyModuleJS extends Module {
  /**
   * Creates an instance of newsInformationLegacyModuleJS
   * @param {Object} options - options
   * @param {Object} context context
   */
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });
    if (spaParams.siteParams.jsTimer) {
      benchmarkUtility.init(this);
    }
  }

  /**
   * Initializes the module
   * @returns {void}
   */
  init() {}
}
registerModuleClass({
  moduleClass: newsInformationLegacyModuleJS,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { newsInformationLegacyModuleJS as default, moduleConfig };
